<template>
    <div id="user-header-container">
        <b-row>
            <b-col class="col-12">
                <h4 v-if="this.Mode" class="page-title text-truncate">
                    {{ $t('UnifiedProfile.EditTitle') }}
                </h4>
                <h4 v-if="!this.Mode" class="page-title text-truncate">
                    {{ $t('UnifiedProfile.AddTitle') }}
                </h4>

                <MdTitle
                    v-bind:Text="$t('userHeader.UserDetails')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_GENERAL_SUBTITLE'"
                />
                <b-row>
                    <b-col md="3" lg="3" sm="12">
                        <MdEdit
                            v-bind:Label="$t('employee.UserID')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'UserId'"
                            v-bind:MaxLengthProp="6"
                            v-bind:isRequired="true"
                            v-bind:isValid="isUserIdValid"
                            v-bind:isReadOnly="this.Mode"
                            v-bind:Id="'input_userid_id'"
                            v-on:blur="OnUserIdBlur(User.userId)"
                            v-model="User.userId"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdEdit
                            v-bind:Label="$t('Shared.FirstName')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'FirstName'"
                            v-bind:Id="'input_firstname_id'"
                            v-bind:MaxLengthProp="64"
                            v-bind:isRequired="true"
                            v-model="User.firstname"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdEdit
                            v-bind:Label="$t('Shared.LastName')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'LastName'"
                            v-bind:Id="'input_lastname_id'"
                            v-bind:MaxLengthProp="64"
                            v-bind:isRequired="true"
                            v-model="User.lastname"
                        >
                        </MdEdit>
                    </b-col>
                    <b-col sm="12" md="3" lg="3">
                        <MdSelect
                            v-bind:Label="$t('userHeader.Role')"
                            data-field="Role"
                            v-bind:Options="RoleList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="User.roleCode"
                            v-bind:FeedBackText="$t('userHeader.rRequiredMsg')"
                            v-bind:isValid="isRoleValid"
                            v-bind:isRequired="true"
                            v-bind:Multiple="false"
                            :Input="ChangeRol"
                            v-bind:IsDisabled="isReadOnly"
                        />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3" sm="12" v-if="!this.Mode">
                        <MdPassword
                            v-bind:Label="$t('insuranceSetup.Password')"
                            v-bind:TypeProp="'password'"
                            v-bind:Name="'Password'"
                            v-bind:MaxLengthProp="45"
                            v-bind:isRequired="true"
                            v-bind:isValid="isPasswordValid"
                            v-model="User.password"
                            v-on:isValidPassword="IsValidPass($event)"
                            v-bind:Autocomplete="false"
                        >
                        </MdPassword>
                    </b-col>
                    <b-col md="3" sm="12" v-if="!this.Mode">
                        <MdPassword
                            v-bind:Label="$t('ChangePassWord.ConfirmPass')"
                            v-bind:TypeProp="'password'"
                            v-bind:Name="'Verify'"
                            v-bind:MaxLengthProp="45"
                            v-bind:isRequired="true"
                            v-bind:isValid="isConfirmPasswordValid"
                            v-on:isValidPassword="IsValidPass($event)"
                            v-model="User.verify"
                            v-bind:Autocomplete="false"
                        >
                        </MdPassword>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdDateTime
                            :Label="$t('userHeader.pExpDate')"
                            :Model="User.passwordExpirationDate"
                            @input="User.passwordExpirationDate = $event"
                            :Id="'EmployeeExpDateDob'"
                            :Type="'date'"
                            :isConfirm="false"
                            :ReadOnly="isReadOnly"
                            :isValid="isValidExpDate"
                        >
                        </MdDateTime>
                    </b-col>
                </b-row>

                <MdTitle
                    v-bind:Text="$t('userHeader.Restrictions')"
                    v-bind:isSubtitle="true"
                    v-bind:Name="'T_RESTRICTION_SUBTITLE'"
                />
                <b-row>
                    <b-col md="3" lg="3" sm="12">
                        <MdCheckBox
                            v-bind:Label="$t('userHeader.IsSupervisor')"
                            v-bind:Name="'checkbox-isSupervisor'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            v-model="User.isSupervisor"
                        />
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdCheckBox
                            v-bind:Label="$t('userHeader.ccAlert')"
                            v-bind:Name="'checkbox-iscancreatealert'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            v-model="User.canCreateAlerts"
                        />
                    </b-col>
                    <b-col md="3" lg="3" sm="12">
                        <MdCheckBox
                            v-bind:Label="$t('userHeader.CanSeeRestricted')"
                            v-bind:Name="'checkbox-canseeRestricted'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            v-model="User.isVIP"
                        />
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdRadioGroup
                            v-bind:Label="$t('userHeader.aUser')"
                            v-model="User.isActive"
                            v-bind:Options="activeUserlist"
                            v-bind:Name="'Active_User'"
                            v-bind:isReadOnly="this.isReadOnly"
                        />
                    </b-col>
                </b-row>

                <b-row v-if="employeeDoctorRowVisible">
                    <b-col
                        md="3"
                        lg="3"
                        sm="12"
                        v-if="employeeDoctor.checkBoxVisible.userIsEmployee"
                    >
                        <MdCheckBox
                            v-bind:Label="$t('userHeader.IsEmployee')"
                            v-bind:Name="'checkbox-isEmployee'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            v-model="employeeDoctor.userIsEmployee"
                        />
                    </b-col>
                    <b-col md="3" lg="3" sm="12" v-if="employeeDoctor.checkBoxVisible.userIsDoctor">
                        <MdCheckBox
                            v-bind:Label="$t('userHeader.IsDoctor')"
                            v-bind:Name="'checkbox-isDoctor'"
                            v-bind:ClassProp="'AlignCheck'"
                            v-bind:CheckedValue="true"
                            v-bind:UncheckedValue="false"
                            v-model="employeeDoctor.userIsDoctor"
                        />
                    </b-col>
                </b-row>

                <personalPanel
                    v-if="employeeDoctor.userIsEmployee || employeeDoctor.userIsDoctor"
                    v-model="editableInfo"
                    :Mode="this.Mode"
                    :isReadOnly="this.isReadOnly"
                    ref="personalPanel"
                >
                </personalPanel>

                <employeePanel
                    ref="employeePanel"
                    v-if="employeeDoctor.userIsEmployee"
                    v-model="editableEmployee"
                    :Mode="this.Mode"
                    :isReadOnly="this.isReadOnly"
                    :typeList="TypeList"
                    :cellCompanyList="this.CellCompanyList"
                    :ethnicityList="this.EthnicityList"
                    :credentialsList="this.CredentialsList"
                    :branchLocationList="this.BranchLocationList"
                    :signaturePadList="this.SignaturePadList"
                    :insuranceList="this.InsuranceList"
                    :documentTypeList="this.documentTypeList"
                >
                </employeePanel>

                <doctorPanel
                    v-if="employeeDoctor.userIsDoctor"
                    v-model="editableDoctor"
                    :Mode="this.Mode"
                    :isReadOnly="this.isReadOnly"
                    :specialtyList="this.SpecialtyList"
                    :insuranceList="this.InsuranceList"
                >
                </doctorPanel>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btnuserlist'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="DiscardChanges"
            />
            <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:Name="'btnSaveUser'"
                v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                v-on:click="SaveOrEdit"
            />
            <MdButton
                v-if="this.Mode"
                v-bind:Label="$t('userHeader.rPassword')"
                v-bind:Name="'btnresetpassUser'"
                v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                v-on:click="CallModalResetPassword"
            />
        </div>

        <ModalUserResetPassword
            v-bind:TitleWindow="$t('userHeader.rPassword')"
            @getCodeConditionOK="OnReturnDataModalResetPassword($event)"
            v-bind:ModalId="modalResetPasswordId"
            @getCodeConditionCancel="OnReturnCancelModalResetPassword($event)"
        >
        </ModalUserResetPassword>
    </div>
</template>

<script>
import EnumService from '@/services/enum.service';
import Utils from '@/common/utils.js';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import CompanieService from '@/services/companies.service';
import GlobalService from '@/services/global.service';
import { EventBus } from '@/event-bus.js';
import UserService from '@/services/user.service';
import moment from 'moment';
import Permission from '@/common/Permission';
import doctorPanel from '../employee_doctor/doctorPanel.vue';
import employeePanel from '../employee_doctor/employeePanel.vue';
import personalPanel from '../employee_doctor/PersonalPanel.vue';
import DoctorService from '@/services/doctor.service';
import EmployeeTypesService from '@/services/employeetypes.service';
import RaceService from '@/services/race.service';
import EmployeeCredentialService from '@/services/employeecredential.service';
import BranchLocation from '@/services/branchlocation.service';
import InsuranceService from '@/services/insurance.service';
import DocumentTypeService from '@/services/documenttype.service';

let elemSaveBtn = '';
export default {
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$t('userHeader.uSetup'),
                    okTitle: this.$t('Shared.Save'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (!value) {
                        this.checkExistFavorite('/app/users');
                        next();
                    } else {
                        this.SaveOrEdit();
                        next();
                    }
                });
        } else {
            next();
        }
    },

    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'UserEmployeeDoctorDetails',
    components: {
        doctorPanel,
        employeePanel,
        personalPanel
    },

    data() {
        return {
            CodeExist: false,
            modalResetPasswordId: 'ModalResetPasswordId',
            RoleList: [],
            isValidExpDate: false,
            activeUserlist: EnumService.YesNoOptionsInverted,
            MaskDateFrom: '##/##/####',
            isUserIdValid: true,
            isRoleValid: true,
            isPasswordValid: true,
            isConfirmPasswordValid: true,
            OptionsRightMenu: {
                visible: false,
                ItemsList: [],
                btnvisible: false,
                itemdisabled: false,
                PatientCode: '',
                Mode: this.edit_mode,
                favButtonAtion: false
            },
            ProviderItems: [],
            isFirstNameValid: true,
            isLastNameValid: true,
            Userdescription: '',
            User: {
                passwordExpirationDate: ''
            },
            DataUser: {},
            Companies: [],
            SpecialtyList: [],
            TypeList: [],
            CellCompanyList: [],
            EthnicityList: [],
            CredentialsList: [],
            BranchLocationList: [],
            SignaturePadList: [],
            InsuranceList: [],
            documentTypeList: [],
            UserId: null,

            fields: [
                {
                    key: 'Insurance',
                    sortable: true,
                    label: this.$tc('Insurance.Insurance'),
                    class: 'text-rigth'
                },
                {
                    key: 'ProviderId',
                    sortable: true,
                    label: this.$t('employee.ProviderId'),
                    class: 'text-rigth'
                }
            ],
            Mode: this.$attrs.editMode,
            isReadOnly: false,
            pendingChanges: false,
            reg: /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/,
            editableEmployee: {
                code: '',
                description: '',
                credentials: '',
                firstname: '',
                lastname: '',
                license: '',
                initial: '',
                dayPhone: '',
                nightphone: '',
                address1: '',
                address2: '',
                zip: '',
                beeper: '',
                city: '',
                title: '',
                state: '',
                empProv: '',
                ethcode: '',
                country: '',
                eMail: '',
                status: '',
                county: '',
                pool: '',
                ssn: '',
                textAddress: '',
                needCoSigner: 'N',
                hireddate: null,
                signaturePad: '',
                dob: null,
                sex: '',
                taxonomy: '',
                taxonomyDescription: '',
                cellCompany: '',
                userid: '',
                useridDescription: '',
                branchLocation: '',
                employeeId: '',
                webFormatStamp: '',
                emptype: '',
                terminatedate: null,
                emp_Prov: '',
                employeestamp: '',
                employeestampExt: '',
                npi: '',
                newCropUserType: '',
                employeesignature: '',
                employeesignatureExt: '',
                daysBeforeAppt: 0,
                daysAfterAppt: 0,
                webFormatSignature: '',
                requiredLocation: false,
                allowSelectMultProg: false,
                selectConsInsurances: false,
                insuranceList: null,
                enforceSelectProgram: false,
                showOnlyPatientFromScheduler: false,
                isSelfDriver: false,
                requestSigCreateMed: false,
                requiredPharmacyLocation: false,
                requestSigMars: false,
                requestSigReceivedItems: false,
                requestSigFillOrders: false,
                requestSigUndoFillOrders: false,
                requestSigItemsRelocation: false,
                requestSigCreateCpoe: false,
                requestSigReturnItems: false,
                requestSigRemoveItems: false,
                requestSigCreateOrders: false,
                requestSigTars: false,

                buildingCodesList: [],
                programCodesList: [],
                pharmacyCodesList: [],
                pharmacyRemovalCodesList: [],
                providerCodesList: [],
                documentCodesList: [],
                documentMgrCodesList: []
            },
            editableDoctor: {
                code: '',
                company: '',
                contactFirstName: '',
                contact: '',
                locality: '',
                doctorId: '',
                credentials: '',
                upin: '',
                ssn: '',
                ein: '',
                me: '',
                npi: '',
                type: ''
            },
            editableInfo: {
                initial: '',
                eMail: '',
                address1: '',
                address2: '',
                zip: '',
                city: '',
                state: '',
                county: '',
                country: '',
                fax: ''
            },
            employeeDoctor: {
                checkBoxVisible: {
                    userIsDoctor: true,
                    userIsEmployee: true
                },
                userIsDoctor: false,
                userIsEmployee: false
            },
            loading: true
        };
    },

    computed: {
        employeeDoctorRowVisible() {
            return (
                !this.Mode ||
                this.employeeDoctor.checkBoxVisible.userIsDoctor ||
                this.employeeDoctor.checkBoxVisible.userIsEmployee
            );
        }
    },

    methods: {
        validate_entries() {
            this.isValidExpDate =
                !this.User.passwordExpirationDate ||
                this.User.passwordExpirationDate.trim().length === 0
                    ? true
                    : Utils.isValidDate(this.User.passwordExpirationDate);

            let personalPanelValid = true;
            if (this.$refs.personalPanel) {
                personalPanelValid = this.$refs.personalPanel.validate_entries();
            }

            let employeePanelValid = true;
            if (this.$refs.employeePanel) {
                employeePanelValid = this.$refs.employeePanel.validate_entries();
            }

            return this.isValidExpDate && personalPanelValid && employeePanelValid;
        },

        OnUserIdBlur(value) {
            if (!this.Mode) {
                if (value && value.trim().length !== 0) {
                    UserService.checkUserByCode(value.trim(), true, true)
                        .then(response => {
                            if (response.status == '200' && response.data) {
                                if (response.data) {
                                    this.showMessage(
                                        this.$tc('Msg.Error'),
                                        this.$t('userHeader.uExists'),
                                        'error'
                                    );
                                    this.CodeExist = true;
                                } else {
                                    this.CodeExist = false;
                                }
                            }
                        })
                        .catch(error => {
                            this.showResponseErrorMessage(error);
                        });
                }
            }
        },

        OnReturnDataModalResetPassword(data) {
            this.pendingChanges = false;
            this.ResetPassword(data);
        },

        CallModalResetPassword() {
            this.$bvModal.show(this.modalResetPasswordId);
        },

        IsValidPass(item){
            if(item.Id === "Password"){
                this.isPasswordValid = item.IsValid;
            }

            if(item.Id === "Verify"){
                this.isConfirmPasswordValid = item.IsValid;
            }
        },

        DiscardChanges() {
            if (!this.pendingChanges) {
                this.checkExistFavorite('/app/unifiedprofile');
            }

            this.$router.push({ name: 'unifiedprofile' });
        },

        async getUser() {
            await UserService.getUserEmployeeDoctor(this.UserId)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        var data = response.data.user;
                        data.isActive = data.isActive ? 'N' : 'Y';
                        //data.passwordExpirationDate = Utils.formatterDateToString(data.passwordExpirationDate);
                        this.User = data;

                        if (response.data.employee) {
                            const employeeData = response.data.employee;
                            employeeData.allowSelectMultProg =
                                employeeData.allowSelectMultProg === null
                                    ? ''
                                    : employeeData.allowSelectMultProg
                                    ? 'Y'
                                    : 'N';
                            employeeData.documentMgrCodesList = employeeData.documentMgrCodesList.map(
                                document => ({
                                    IsNew: false,
                                    Image: Utils.getType(document.extension),
                                    comments: document.comments,
                                    description: document.description,
                                    doccode: document.doccode,
                                    entitycode: document.entitycode,
                                    entitytype: document.entitytype,
                                    expirationDate: document.expirationDateDocument,
                                    extension: document.extension,
                                    fileName: document.fileName,
                                    sysUser: document.sysUser,
                                    scanneddate: document.scanneddate,
                                    contents: document.contents,
                                    seqno: document.seqno
                                })
                            );

                            this.editableEmployee = employeeData;
                            this.editableInfo = {
                                initial: this.editableEmployee.initial,
                                eMail: this.editableEmployee.eMail,
                                address1: this.editableEmployee.address1,
                                address2: this.editableEmployee.address2,
                                zip: this.editableEmployee.zip,
                                city: this.editableEmployee.city,
                                state: this.editableEmployee.state,
                                county: this.editableEmployee.county,
                                country: this.editableEmployee.country,
                                fax: this.editableEmployee.pool
                            };
                        }

                        if (response.data.doctor) {
                            this.editableDoctor = response.data.doctor;
                            this.editableInfo = {
                                initial: this.editableInfo.initial || this.editableDoctor.initial,
                                eMail: this.editableInfo.eMail || this.editableDoctor.email,
                                address1:
                                    this.editableInfo.address1 || this.editableDoctor.address1,
                                address2:
                                    this.editableInfo.address2 || this.editableDoctor.address2,
                                zip: this.editableInfo.zip || this.editableDoctor.zip,
                                city: this.editableInfo.city || this.editableDoctor.city,
                                state: this.editableInfo.state || this.editableDoctor.state,
                                county: this.editableInfo.county || this.editableDoctor.county,
                                country: this.editableInfo.country || this.editableDoctor.country,
                                fax: this.editableInfo.fax || this.editableDoctor.fax
                            };

                            if (this.editableDoctor.providerCodesList) {
                                this.editableDoctor.providerCodesList = this.editableDoctor.providerCodesList.map(
                                    provider => ({
                                        code: provider.doctorCode,
                                        insuranceCode: provider.insuranceCode,
                                        companyName: provider.insuranceName,
                                        providerId: provider.providerId
                                    })
                                );
                            }
                        }

                        this.employeeDoctor.checkBoxVisible.userIsEmployee =
                            response.data.employee === null;
                        this.employeeDoctor.userIsEmployee = response.data.employee !== null;
                        this.employeeDoctor.checkBoxVisible.userIsDoctor =
                            response.data.doctor === null;
                        this.employeeDoctor.userIsDoctor = response.data.doctor !== null;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        ResetPassword(data) {
            UserService.resetPassword(this.UserId, data)
                .then(response => {
                    if (response.status == '200') {
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('userHeader.pChanged'), {
                                    title: this.$t('Msg.SavedSuccessfully'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        AddUser() {
            if (!this.CodeExist) {
                UserService.addUserEmployeeDoctor({
                    User: this.DataUser,
                    Employee: this.prepareEmployeeData(),
                    Doctor: this.prepareDoctorData()
                })
                    .then(response => {
                        if (response.status == '200') {
                            this.pendingChanges = false;
                            this.$router.push({ name: 'unifiedprofile' });
                            setTimeout(
                                () =>
                                    this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                        title: this.$t('Msg.Success'),
                                        autoHideDelay: 5000,
                                        variant: 'success'
                                    }),
                                50
                            );
                        }
                    })
                    .catch(error => {
                        elemSaveBtn.removeAttribute('disabled');
                        this.showResponseErrorMessage(error);
                    });
            } else {
                this.showMessage(this.$tc('Msg.Error'), this.$t('userHeader.uExists'), 'error');
            }
        },

        ChangeRol(e) {
            this.User.roleCode = e ? e.code : '';
        },

        UpdateUser() {
            UserService.updateUserEmployeeDoctor(this.UserId, {
                User: this.DataUser,
                Employee: this.prepareEmployeeData(),
                Doctor: this.prepareDoctorData()
            })
                .then(response => {
                    if (response.status == '200') {
                        this.pendingChanges = false;
                        this.$router.push({ name: 'unifiedprofile' });
                        setTimeout(
                            () =>
                                this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                    title: this.$t('Msg.Success'),
                                    autoHideDelay: 5000,
                                    variant: 'success'
                                }),
                            50
                        );
                    }
                })
                .catch(error => {
                    elemSaveBtn.removeAttribute('disabled');
                    this.showResponseErrorMessage(error);
                });
        },

        PrepareUser() {
            this.DataUser.isActive = this.User.isActive == 'N' ? true : false;
            this.DataUser.userId = this.User.userId;
            this.DataUser.firstname = this.User.firstname;
            this.DataUser.lastname = this.User.lastname;
            this.DataUser.roleCode = this.User.roleCode;
            this.DataUser.password = this.User.password;
            this.DataUser.confirmPassword = this.User.verify;
            this.DataUser.isSupervisor = this.User.isSupervisor;
            this.DataUser.canCreateAlerts = this.User.canCreateAlerts;
            this.DataUser.isVIP = this.User.isVIP;

             /*if (this.User.passwordExpirationDate) {
                this.DataUser.passwordExpirationDate = Utils.formatterToISO2(this.User.passwordExpirationDate);
            }*/

            /*if(this.User.passwordExpirationDate){
        this.DataUser.passwordExpirationDate = Utils.formatterToISO(this.User.passwordExpirationDate, Utils.getShortDateFormat());
      } */
        },

        prepareEmployeeData() {
            if (this.employeeDoctor.userIsEmployee) {
                const employeeCode = this.editableEmployee.code || this.User.userId;
                const allowSelectMultProg = Utils.isNullOrEmptyString(
                    this.editableEmployee.allowSelectMultProg
                )
                    ? null
                    : this.editableEmployee.allowSelectMultProg === 'Y'
                    ? true
                    : false;

                return {
                    userid: this.User.userId,
                    code: employeeCode,
                    address1: this.editableInfo.address1,
                    address2: this.editableInfo.address2,
                    city: this.editableInfo.city,
                    country: this.editableInfo.country,
                    firstname: this.User.firstname,
                    initial: this.editableInfo.initial,
                    lastname: this.User.lastname,
                    phone: this.editableEmployee.phone,
                    state: this.editableInfo.state,
                    zip: this.editableInfo.zip,
                    eMail: this.editableInfo.eMail,
                    county: this.editableInfo.county,
                    beeper: this.editableEmployee.beeper,
                    credentials: this.editableEmployee.credentials,
                    dayphone: this.editableEmployee.dayphone,
                    dob: this.editableEmployee.dob,
                    employeesignature: this.editableEmployee.employeesignature,
                    employeesignatureExt: this.editableEmployee.employeesignatureExt,
                    emptype: this.editableEmployee.emptype,
                    empProv: this.editableEmployee.empProv,
                    ethcode: this.editableEmployee.ethcode,
                    hireddate: this.editableEmployee.hireddate,
                    isSelfDriver: this.editableEmployee.isSelfDriver,
                    license: this.editableEmployee.license,
                    nightphone: this.editableEmployee.nightphone,
                    pool: this.editableInfo.fax,
                    sex: this.editableEmployee.sex,
                    ssn: this.editableEmployee.ssn,
                    status: this.editableEmployee.status,
                    terminatedate: this.editableEmployee.terminatedate,
                    npi: this.editableEmployee.npi,
                    taxonomy: this.editableEmployee.taxonomy,
                    cellCompany: this.editableEmployee.cellCompany,
                    textAddress: this.editableEmployee.textAddress, //VERIFY
                    needCoSigner: this.editableEmployee.needCoSigner,
                    requiredLocation: this.editableEmployee.requiredLocation,
                    requestSigCreateMed: this.editableEmployee.requestSigCreateMed,
                    requestSigMars: this.editableEmployee.requestSigMars,
                    title: this.editableEmployee.title,
                    requestSigReceivedItems: this.editableEmployee.requestSigReceivedItems,
                    requestSigFillOrders: this.editableEmployee.requestSigFillOrders,
                    requestSigItemsRelocation: this.editableEmployee.requestSigItemsRelocation,
                    requestSigReturnItems: this.editableEmployee.requestSigReturnItems,
                    requestSigUndoFillOrders: this.editableEmployee.requestSigUndoFillOrders,
                    requestSigRemoveItems: this.editableEmployee.requestSigRemoveItems,
                    signaturePad: this.editableEmployee.signaturePad,
                    requestSigCreateOrders: this.editableEmployee.requestSigCreateOrders,
                    requestSigTars: this.editableEmployee.requestSigTars,
                    showOnlyPatientFromScheduler: this.editableEmployee
                        .showOnlyPatientFromScheduler,
                    daysBeforeAppt: this.editableEmployee.daysBeforeAppt,
                    daysAfterAppt: this.editableEmployee.daysAfterAppt,
                    enforceSelectProgram: this.editableEmployee.enforceSelectProgram,
                    allowSelectMultProg: allowSelectMultProg,
                    selectConsInsurances: this.editableEmployee.selectConsInsurances, //VErify
                    insuranceList: this.editableEmployee.insuranceList,
                    webFormatSignature: this.editableEmployee.webFormatSignature, //verify
                    branchLocation: this.editableEmployee.branchLocation,
                    requiredPharmacyLocation: this.editableEmployee.requiredPharmacyLocation,
                    newCropUserType: this.editableEmployee.newCropUserType, //verify
                    employeestamp: this.editableEmployee.employeestamp,
                    employeestampExt: this.editableEmployee.employeestampExt,
                    webFormatStamp: this.editableEmployee.webFormatStamp, //verify
                    buildingCodesList: this.editableEmployee.buildingCodesList.map(item => ({
                        employeeCode: employeeCode,
                        buildingCode: item.buildingCode
                    })),
                    programCodesList: this.editableEmployee.programCodesList.map(item => ({
                        employeeCode: employeeCode,
                        programCode: item.programCode
                    })),
                    pharmacyCodesList: this.editableEmployee.pharmacyCodesList.map(item => ({
                        employeeCode: employeeCode,
                        pharmacyCode: item.pharmacyCode
                    })),
                    pharmacyRemovalCodesList: this.editableEmployee.pharmacyRemovalCodesList.map(
                        item => ({
                            employeeCode: employeeCode,
                            pharmacyCode: item.pharmacyCode
                        })
                    ),
                    providerCodesList: this.editableEmployee.providerCodesList.map(item => ({
                        code: employeeCode,
                        providerId: item.providerId,
                        insuranceCode: item.insuranceCode
                    })),
                    documentCodesList: this.editableEmployee.documentCodesList.map(item => ({
                        employeeCode: employeeCode,
                        docCode: item.docCode,
                        recNo: item.recNo,
                        comment: item.comment,
                        expDate: item.expDate
                    })),
                    documentMgrCodesList: this.editableEmployee.documentMgrCodesList.map(item => ({
                        ...item,
                        entitycode: employeeCode
                    }))
                };
            }

            return null;
        },

        prepareDoctorData() {
            if (this.employeeDoctor.userIsDoctor) {
                const doctorCode = this.editableDoctor.code || this.User.userId;

                return {
                    userId: this.User.userId,
                    code: doctorCode,
                    company: this.editableDoctor.company,
                    contactFirstName: this.editableDoctor.contactFirstName,
                    contact: this.editableDoctor.contact,
                    locality: this.editableDoctor.locality,
                    doctorId: this.editableDoctor.doctorId,
                    credentials: this.editableDoctor.credentials,
                    upin: this.editableDoctor.upin,
                    ssn: this.editableDoctor.ssn,
                    ein: this.editableDoctor.ein,
                    me: this.editableDoctor.me,
                    npi: this.editableDoctor.npi,
                    type: this.editableDoctor.type,
                    address1: this.editableInfo.address1,
                    address2: this.editableInfo.address2,
                    city: this.editableInfo.city,
                    country: this.editableInfo.country,
                    fax: this.editableInfo.fax,
                    firstname: this.User.firstname,
                    initial: this.editableInfo.initial,
                    lastname: this.User.lastname,
                    phone: this.editableDoctor.phone,
                    state: this.editableInfo.state,
                    zip: this.editableInfo.zip,
                    email: this.editableInfo.eMail,
                    county: this.editableInfo.county,
                    providerCodesList: this.editableDoctor.providerCodesList.map(item => ({
                        code: doctorCode,
                        providerId: item.providerId,
                        Inscode: item.insuranceCode
                    }))
                };
            }

            return null;
        },

        SaveOrEdit() {
            if (!this.isReadOnly) {
                if (this.validate_entries()) {
                    if (this.validate_required()) {
                        this.PrepareUser();

                        if (this.Mode) {
                            this.UpdateUser();
                        } else {
                            if (this.validatePasswordsFiels()) {
                                this.AddUser();
                            } else {
                                this.showMessage(
                                    this.$tc('Msg.Error'),
                                    this.$t('ModalUserResetPassword.nMatchMsg'),
                                    'errorAutoHide'
                                );
                            }
                        }
                    } else {
                        this.showMessage(
                            this.$tc('Msg.Error'),
                            this.$t('Msg.CheckRedLabeledFields'),
                            'errorAutoHide'
                        );
                    }
                } else {
                    this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('Msg.InvalidFieldValuesDetected'),
                        'errorAutoHide'
                    );
                }
            }
        },

        validate_required() {
            this.isUserIdValid = this.User.userId ? true : false;
            this.isRoleValid = this.User.roleCode && this.User.roleCode.length > 0 ? true : false;

            if (!this.Mode) {
                this.isPasswordValid =
                    this.User.password && this.User.password.length > 0 ? true : false;
                this.isConfirmPasswordValid =
                    this.User.verify && this.User.verify.length > 0 ? true : false;
            } else {
                this.isPasswordValid = true;
                this.isConfirmPasswordValid = true;
            }

            return (
                this.isUserIdValid &&
                this.isRoleValid &&
                this.isPasswordValid &&
                this.isConfirmPasswordValid
            );
        },

        validatePasswordsFiels() {
            var c = this.User.password === this.User.verify;
            this.isConfirmPasswordValid = !c ? false : true;
            return c;
        },

        async getRoles() {
            await UserService.getRols()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.RoleList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        getDateTime() {
            GlobalService.getDateTime()
                .then(response => {
                    if (response.data) {
                      this.User.passwordExpirationDate =  Utils.formatterDateToString(moment(response.data).add('days', this.Companies[0].passwordDays));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getCompanies() {
            await CompanieService.getAll()
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.Companies = response.data;

                        if (this.Companies[0].passwordDays > 0) {
                            this.getDateTime();
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getDoctorSpecialties() {
            await DoctorService.getDoctorSpecialties()
                .then(response => {
                    if (response.status == '200' && response.data && response.data.length > 0) {
                        this.SpecialtyList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getEmployeeTypes() {
            const param = {
                Active: true
            };
            this.TypeList = [];
            await EmployeeTypesService.getAllEmployeeType(param)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.TypeList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getCellPhoneCompany() {
            let param = {
                CodeType: 'CarrierList',
                OrderBy: 'SeqNo'
            };
            await GlobalService.getGlobalCustom(param)
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.CellCompanyList = response.data.map(value => ({
                            code: value.value,
                            description: value.description
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getRaces() {
            await RaceService.getAll()
                .then(response => {
                    if (response.status == '200') {
                        this.EthnicityList = response.data;
                    }
                })
                .catch(error => {
                    if (error.response) {
                        this.showMessage(this.$tc('Msg.Error'), error, 'error');
                    }
                });
        },

        async getCredential() {
            await EmployeeCredentialService.getEmployeeCredential()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.CredentialsList = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getBranchLocation() {
            await BranchLocation.GetBranchLocations()
                .then(response => {
                    if (response.status == '200') {
                        this.BranchLocationList = [
                            { code: '<ALL>', description: '<ALL>' },
                            ...response.data
                        ];
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getSignaturePad() {
            let param = {
                CodeType: 'SignaturePad',
                OrderBy: 'Description'
            };
            await GlobalService.getGlobalCustom(param)
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.SignaturePadList = response.data.map(value => ({
                            code: value.value,
                            description: value.description
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getInsurances() {
            await InsuranceService.getAllInsurances({})
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.InsuranceList = response.data.map(value => ({
                            code: value.insurancecode,
                            description: value.company
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getDocumentType() {
            await DocumentTypeService.getAll({})
                .then(response => {
                    if (response.status == '200' && response.data.length > 0) {
                        this.documentTypeList = response.data.map(value => ({
                            code: value.code,
                            description: value.description
                        }));
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async Initialize() {
            await Promise.allSettled([
                this.getRoles(),
                this.getDoctorSpecialties(),
                this.getEmployeeTypes(),
                this.getCellPhoneCompany(),
                this.getRaces(),
                this.getCredential(),
                this.getBranchLocation(),
                this.getSignaturePad(),
                this.getInsurances(),
                this.getDocumentType()
            ]);

            this.User.isActive = 'N';
            this.UserId = this.$route.params.id;

            if (this.Mode) {
                await this.getUser();
            } else {
                await this.getCompanies();
            }
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';
            }
        },

        checkUserAction() {
            if (elemSaveBtn.disabled) {
                elemSaveBtn.removeAttribute('disabled');
            }
        }
    },

    async mounted() {
        await this.Initialize();
        setTimeout(() => {
            elemSaveBtn = document.getElementById('btnSaveUser');
            elemSaveBtn.setAttribute('disabled', '');
            this.loading = false;
        }, 50);
    },

    created() {
        this.OptionsRightMenu.ItemsList = [];
        let layoutStatus = this.$store.state.layoutStatus;
        switch (layoutStatus) {
            case 'L0R1':
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
                break;
            default:
                this.OptionsRightMenu.favButtonAtion = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        EventBus.$on('onChanged', e => {
            if (!this.loading) {
                this.pendingChanges = e.Changed;
                this.checkUserAction();
            }
        });

        window.addEventListener('beforeunload', this.beforeWindowUnload);
    },

    beforeDestroy() {
        window.removeEventListener('beforeunload', this.beforeWindowUnload);
        EventBus.$off('onChanged');
    }
};
</script>
